module.exports = __webpack_public_path__ + "static/media/lilcrispyicyhot.d69bc6fe.webp";